import { request } from '@umijs/max';

export async function getRecentPeopleViewed() {
  return request('/people-v2/recently-viewed', {
    method: 'GET',
  });
}

export async function getRecentProductViewed() {
  return request('/data/recent-product-viewed', {
    method: 'GET',
  });
}

export async function getRecentLists() {
  return request('/data/get_recent_product_and_people_list', {
    method: 'GET',
  });
}

export async function getTopIngredientsAndPackaging() {
  return request('/data/top_ingredients_and_packaging', {
    method: 'GET',
  });
} 